import ContinuePage from "@components/ContinuePage"

export default function PhotoWinPreviewPage() {
  return <ContinuePage emoji="✨" translationKey="abPreviewV3.photoWin" />
}
